import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ThemeProvider } from "./context/ThemeContext";
import { BrandingProvider } from "./context/BrandingContext";
import { registerServiceWorker } from "./pwa";
import { startActivityTracking } from "./utils/activity";

// Before the first render, so the very first API call already reports the
// interaction that got the user here. Feeds the server-side idle timeout.
startActivityTracking();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <BrandingProvider>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </BrandingProvider>
  </React.StrictMode>,
);

// PWA bootstrap — registers the service worker, captures the
// beforeinstallprompt event so the Layout can offer an "Install" button.
// Skipped in dev mode (see pwa.ts).
registerServiceWorker();
